import styled from 'styled-components';

const Header = styled.div`
  background-color: #011f4b;
  color: white;
  font-size: 2rem;
  text-align: center;
  padding: 40px;
`;

export default Header;
